const mobileCardGallery = window.matchMedia('(max-width: 749px)');

const loadMobileCardSecondary = (visual) => {
  const image = visual.querySelector('.ab-card__image--secondary[data-ab-mobile-srcset]');
  if (!image) return;
  image.srcset = image.dataset.abMobileSrcset;
  image.src = image.dataset.abMobileSrc;
  delete image.dataset.abMobileSrcset;
  delete image.dataset.abMobileSrc;
};

if (mobileCardGallery.matches && 'IntersectionObserver' in window) {
  const primaryObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(({ isIntersecting, target }) => {
      if (!isIntersecting) return;
      const primary = target.querySelector('.ab-card__image--primary');
      if (primary) primary.loading = 'eager';
      observer.unobserve(target);
    });
  }, { rootMargin: '1400px 0px' });
  const secondaryObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(({ isIntersecting, target }) => {
      if (!isIntersecting) return;
      loadMobileCardSecondary(target);
      observer.unobserve(target);
    });
  }, { rootMargin: '700px 0px' });
  document.querySelectorAll('[data-ab-card-visual]').forEach((visual) => {
    primaryObserver.observe(visual);
    secondaryObserver.observe(visual);
  });
}

const setCardImage = (visual, showSecondary) => {
  visual.dataset.requestedActive = String(showSecondary);
  const secondary = visual.querySelector('.ab-card__image--secondary');
  if (showSecondary && mobileCardGallery.matches) loadMobileCardSecondary(visual);
  const apply = () => {
    if (visual.dataset.requestedActive !== String(showSecondary)) return;
    visual.dataset.active = String(showSecondary);
    visual.querySelectorAll('.ab-card__pagination-mark').forEach((mark, index) => {
      mark.classList.toggle('is-active', index === Number(showSecondary));
    });
    visual.querySelector('[data-ab-card-status]').textContent = `Image ${showSecondary ? 2 : 1} sur 2`;
  };

  if (showSecondary && secondary && (!secondary.complete || secondary.naturalWidth <= 1)) {
    secondary.addEventListener('load', apply, { once: true });
    return;
  }
  apply();
};

document.addEventListener('touchstart', (event) => {
  if (!mobileCardGallery.matches) return;
  const visual = event.target.closest('[data-ab-card-visual]');
  if (!visual?.querySelector('.ab-card__image--secondary')) return;
  loadMobileCardSecondary(visual);
  visual.dataset.touchX = String(event.changedTouches[0].screenX);
  visual.dataset.touchY = String(event.changedTouches[0].screenY);
}, { passive: true });

document.addEventListener('touchend', (event) => {
  if (!mobileCardGallery.matches) return;
  const visual = event.target.closest('[data-ab-card-visual]');
  if (!visual || visual.dataset.touchX === undefined) return;
  const distanceX = event.changedTouches[0].screenX - Number(visual.dataset.touchX);
  const distanceY = event.changedTouches[0].screenY - Number(visual.dataset.touchY);
  delete visual.dataset.touchX;
  delete visual.dataset.touchY;
  if (Math.abs(distanceX) < 38 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.25) return;
  setCardImage(visual, distanceX < 0);
  visual.dataset.swiped = 'true';
  setTimeout(() => { delete visual.dataset.swiped; }, 350);
}, { passive: true });

document.addEventListener('touchcancel', (event) => {
  const visual = event.target.closest('[data-ab-card-visual]');
  if (!visual) return;
  delete visual.dataset.touchX;
  delete visual.dataset.touchY;
}, { passive: true });

document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-ab-card-visual] .ab-card__image-link');
  if (link?.closest('[data-ab-card-visual]').dataset.swiped === 'true') event.preventDefault();
}, true);

document.addEventListener('click', (event) => {
  const menu = document.querySelector('.ab-header__mobile-menu[open]');
  if (menu && !menu.contains(event.target)) menu.removeAttribute('open');
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.ab-header__mobile-menu[open]');
  if (menu) {
    menu.removeAttribute('open');
    menu.querySelector('summary')?.focus();
  }
});

let headerScrollFrame = 0;
const updateHeaderScrollState = () => {
  document.querySelector('[data-ab-header]')?.classList.toggle('is-scrolled', window.scrollY > 16);
  headerScrollFrame = 0;
};

updateHeaderScrollState();
window.addEventListener('scroll', () => {
  if (!headerScrollFrame) headerScrollFrame = requestAnimationFrame(updateHeaderScrollState);
}, { passive: true });
window.addEventListener('pageshow', updateHeaderScrollState);
document.addEventListener('shopify:section:load', updateHeaderScrollState);
